import {
  EmptyState,
  EmptyStateContainer,
} from 'module/ui/components/atoms/empty-state';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { FormattedMessage } from 'react-intl';

type AccountPeopleEmptyStateProps = {
  onPrimaryAction: VoidFunction;
};
export const AccountPeopleNoSearchResult = ({
  onPrimaryAction,
}: AccountPeopleEmptyStateProps) => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={
          <FontAwesomeIcon
            icon={faUser}
            size={50}
            iconSize={40}
            color="transparent"
          />
        }
        title={
          <FormattedMessage id="account.people.empty_state.no_search_result.title" />
        }
        message={
          <FormattedMessage id="account.people.empty_state.no_people.message" />
        }
        primaryCTA={
          <EmptyState.CallToAction.Primary onClick={onPrimaryAction}>
            <FormattedMessage id="clear_search" />
          </EmptyState.CallToAction.Primary>
        }
      />
    </EmptyStateContainer>
  );
};
